import { connect } from 'react-redux';
import { NText } from '@fttb/common';
import { getDeviceTitle } from "../../../../store/blocks/devices/selectors";
var mapStateToProps = function mapStateToProps(state) {
  return {
    children: getDeviceTitle(state),
    size: 'size2-m',
    tagType: 'h2'
  };
};
export var DeviceTitle = connect(mapStateToProps)(NText);